import classNames from 'classnames';
import { useCallback, useLayoutEffect, useRef, useState } from 'react';
import { Flex, Heading } from 'yoso';
import { T } from '~/components/I18n';
import hourglass from '~/components/Icon/hourglass.png';
import { LevelUpToken, useLevelUpStatus } from '~/components/LevelUp/LevelUp.hooks';
import { Progress } from '~/components/Progress';
import cube from '../Result/cube.gif';
import './LevelUpLoading.scss';

export type LevelUpLoadingProps = LevelUpToken & {
  className?: string;
  onSuccess?: () => void;
};

export const LevelUpLoading = ({ id, className, onSuccess }: LevelUpLoadingProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(false);
  const { data: { status = '' } = {} } = useLevelUpStatus(id, {
    enabled: active,
  });

  const onTransitionEnd = useCallback(() => {
    if (status === 'COMPLETED') {
      onSuccess?.();
    }
  }, [status, onSuccess]);

  useLayoutEffect(() => {
    // NOTE Update DOM immediately
    ref.current?.offsetWidth;
    setActive(status !== 'COMPLETED');
  }, [status]);

  return (
    <Flex
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
      className={classNames(
        'level-up-loading',
        status.toLowerCase(),
        {
          active,
        },
        className
      )}
      onTransitionEnd={onTransitionEnd}
      ref={ref}
      data-event="impression"
      data-event-category="levelup_loading_popup"
      data-event-impression-id="{category}">
      <div className="level-up-loading-header">
        <img
          src={hourglass}
          className="level-up-loading-image"
          alt="loading..."
          width={160}
          height={160}
        />
      </div>
      <div className="level-up-loading-body">
        <Heading level={4} className="level-up-loading-title">
          <T name="citizen_membership_levelup_processing_popup_desc1" />
        </Heading>
        <Progress max={100} bubble={false} className="level-up-loading-progress" />
      </div>
      <div className="level-up-loading-footer">
        <p className="level-up-loading-description">
          <T name="citizen_membership_levelup_processing_popup_desc2" />
        </p>
      </div>
      <link rel="preload" as="image" href={cube} />
    </Flex>
  );
};
